import React, { useState, useEffect } from 'react'
import { Button, Flex, message, Spin, Splitter } from 'antd';
import { useScreenConfig } from '../hook/GameConfigHook'
import InputFormByObject from '../common/dynamic-form/InputFormByObject';
import UIObject from '../common/dynamic-form/UIObject';
import BaseGameObject from '../objects/BaseGameObject';


export default function SC02_GameConfig(props) {
    const { screens, updateScreenConfig } = useScreenConfig();
    const [selectedGameType, setSelectedGameType] = useState(null)
    const [totalScreen, setTotalScreen] = useState(0);
    const [finalData, setFinalData] = useState(null);
    const [messageApi, contextHolder] = message.useMessage();

    useEffect(() => {
        if (screens && Array.isArray(screens))
            setTotalScreen(screens.length)
    }, [screens])

    const CreateNewGame = () => {
        setSelectedGameType(null)
        const newGame = new BaseGameObject({ key: `sc${totalScreen + 1}` });
        newGame.addLockedField('key');
        setSelectedGameType(newGame)
    }

    const onSubmit = async (values) => {
        if (finalData) {
            let res = await updateScreenConfig(finalData);
            // if (res)
                messageApi.success("Update Game config successful!")
        }
    }

    return (
        <>
            {contextHolder}
            <Splitter
                style={{
                    height: "100%",
                    boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
                }}
            >
                <Splitter.Panel defaultSize="20%" min="10%" max="70%" style={{ padding: '10px' }}>
                    <Flex style={{ marginBottom: '20px' }} justify='space-between'>
                        <div style={{ fontStyle: 'italic', fontSize: '11pt' }}>Danh sách màn hình mini game: </div>
                        <Button type='primary' onClick={CreateNewGame}>New</Button>
                    </Flex>
                    <Flex vertical gap={'small'}>
                        {
                            screens == null ?
                                <Spin />
                                : ((Array.isArray(screens) && screens.length > 0) ?
                                    screens.map((screen, index) => {
                                        console.log("SCREEN: ", screen)
                                        return (
                                            <Button key={index} onClick={e => {
                                                const iGame = new BaseGameObject(screen)
                                                iGame.addLockedField('gameType')
                                                iGame.addHiddenField('key')
                                                setSelectedGameType(iGame)
                                            }}>
                                                {screen.index}. {screen.name}
                                            </Button>
                                        );
                                    })
                                    : <div>Cannot found any screen configs</div>)
                        }
                    </Flex>
                </Splitter.Panel>
                <Splitter.Panel style={{ padding: '10px' }}>
                    <div>
                        {
                            selectedGameType ?
                                <InputFormByObject uiObject={selectedGameType} submitButton="Lưu" onSubmit={onSubmit} onChange={(data) => { setFinalData(data) }} />
                                : null
                        }
                    </div>
                </Splitter.Panel>
            </Splitter>
        </>
    )
}